type Resolver = { resolve: (token: string) => void; reject: (e: Error) => void }

let pending: Resolver | null = null

declare global {
  interface Window {
    __nativeAuth?: {
      resolveGoogle: (token: string) => void
      rejectGoogle: (msg: string) => void
    }
    webkit?: {
      messageHandlers?: {
        googleSignIn?: { postMessage: (msg: unknown) => void }
      }
    }
  }
}

export function isNativeGoogleSignInAvailable(): boolean {
  return (
    typeof window.webkit?.messageHandlers?.googleSignIn?.postMessage ===
    'function'
  )
}

export function signInWithNativeGoogle(): Promise<string> {
  if (!isNativeGoogleSignInAvailable()) {
    return Promise.reject(
      new Error('Native Google sign-in is not available'),
    )
  }
  if (pending) {
    return Promise.reject(new Error('Sign-in already in progress'))
  }
  return new Promise<string>((resolve, reject) => {
    pending = { resolve, reject }
    window.webkit!.messageHandlers!.googleSignIn!.postMessage({ v: 1 })
  })
}

window.__nativeAuth = {
  resolveGoogle(token) {
    const p = pending
    pending = null
    p?.resolve(token)
  },
  rejectGoogle(msg) {
    const p = pending
    pending = null
    p?.reject(new Error(msg || 'Native Google sign-in failed'))
  },
}
